import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ema-spinner',
  templateUrl: './ema-spinner.component.html',
  styleUrls: ['./ema-spinner.component.css']
})
export class EmaSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}